import React from 'react'
import GitHubIcon from '@mui/icons-material/GitHub';
import Roomlo from '../../images/roomlo.png';
import SigninWithGoogle from '../../images/home.png';
import LoginWithOTP from '../../images/login with otp.png';
import './Pro.css'
import { Link } from 'react-router-dom';

const Pro = () => {
  return (
    <>


      {/* Project 1 */}
      <div className="card">
        <button className="mail">

        </button>
        <div className="profile-pic">
          <img src={SigninWithGoogle} alt="" />
        </div>
        <div className="bottom">
          <div className="content">
            <span className="name">Login With Google</span>
            <span className="about-me">Access user profile information from Google.</span>
          </div>
          <div className="bottom-bottom">
            <div className="social-links-container">
              <GitHubIcon />
            </div>
            <button className="button">Preview</button>
          </div>
        </div>
      </div>


      {/* Project 2 */}
      <div className="card">
        <button className="mail">

        </button>
        <div className="profile-pic">
          <img src={LoginWithOTP} alt="" />
        </div>
        <div className="bottom">
          <div className="content">
            <span className="name">Login With OTP</span>
            <span className="about-me">1. User Registration 2.Login 3.OTP Verification 4.uthentication</span>
          </div>
          <div className="bottom-bottom">
            <div className="social-links-container">
              <Link to='https://github.com/abhishekmaurya149'><GitHubIcon /></Link>

            </div>
            <button className="button">
              <Link to='#'>Preview</Link>
            </button>
          </div>
        </div>
      </div>

      {/* Project 3 */}
      <div className="card">

        <div className="profile-pic">
          <img src={Roomlo} alt="" />
        </div>
        <div className="bottom">
          <div className="content">
            <span className="name">Roomlo</span>
            <span className="about-me">Finding a room is just a click away and Verified listing and reliable landlords.</span>
          </div>
          <div className="bottom-bottom">
            <div className="social-links-container">
              <GitHubIcon />
            </div>
            <button className="button">Preview</button>
          </div>
        </div>
      </div>

    </>
  )
}

export default Pro
